import { createStore, useStore as useBaseStore, Store } from 'vuex'
import { InjectionKey } from 'vue'
import { state, State } from '@/store/state'
import { getters } from '@/store/getters'
import { actions } from '@/store/actions'
import { mutations } from '@/store/mutations'

export const key: InjectionKey<Store<State>> = Symbol('store-key')

export const store = createStore<State>({
    state,
    getters,
    actions,
    mutations
})

export function useStore (): Store<State> {
    return useBaseStore(key)
}
